import { State } from "@bluefalcon/clients-management-client-fetch";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { stateService } from "../../services";
import { Box, Heading, Flex, Text } from "@chakra-ui/react";
import { LoadingSpinner } from "@bluefalcon/components-package";
import { CountiesTable } from "../../components/counties-table/counties-table.comp";


export function StateDetails() {
    const { stateId } = useParams();
    const navigate = useNavigate();
    const [state, setState] = useState<State>();
    const [isLoading, setIsLoading] = useState(false);

    const getStateById = async () => {
        if (!stateId) {
            navigate('/states');
            return;
        }
        try {
            setIsLoading(true);
            const foundState = await stateService.getStateById(stateId);
            setState(foundState);
        } catch (e: any) {
            navigate('/states');
        } finally {
            setIsLoading(false);
        }

    };

    useEffect(() => {
        getStateById();
    }, []);

    if (isLoading || !state) {
        return <LoadingSpinner />
    }

    return (
        <Box p={4}>
            <Flex>
                <Heading as={'h1'}>{state.name}</Heading>
            </Flex>
            <Box
                mt={5}
                borderWidth="1px"
                borderRadius="lg"
                p={6}
                boxShadow="md"
                mb={6}
                bg="white"
            >
                <Flex mb={4}>
                    <Text fontWeight="bold" mr={2}>
                        ID:
                    </Text>
                    <Text>{state.id}</Text>
                </Flex>
                <Flex mb={4}>
                    <Text fontWeight="bold" mr={2}>
                        Name:
                    </Text>
                    <Text>{state.name}</Text>
                </Flex>
            </Box>
            <Box mt={10}>
                <Heading size={'md'}>Counties</Heading>
                <CountiesTable onChange={(st) => setState(st)} state={state} />
            </Box>
        </Box>
    );
}
